module.exports = __webpack_public_path__ + "static/media/server.9a95aa1c.svg";